import React from 'react'

const ModalRoot: React.FC = () => {
  return <div id="modal-root" data-testid="modal-root" />
}

export default ModalRoot
